import { render, staticRenderFns } from "./StudyViewer.vue?vue&type=template&id=6b3650a0&scoped=true"
import script from "./StudyViewer.vue?vue&type=script&lang=js"
export * from "./StudyViewer.vue?vue&type=script&lang=js"
import style0 from "./StudyViewer.vue?vue&type=style&index=0&id=6b3650a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3650a0",
  null
  
)

export default component.exports